var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7443 7.37752L9.9661 1.59923C9.80116 1.43429 9.58132 1.34375 9.34692 1.34375C9.11225 1.34375 8.89255 1.43442 8.7276 1.59923L8.20299 2.12397C8.03818 2.28865 7.94738 2.50862 7.94738 2.74315C7.94738 2.97756 8.03818 3.20494 8.20299 3.36962L11.5739 6.74793H0.864383C0.381525 6.74793 0 7.12595 0 7.60893V8.35078C0 8.83377 0.381525 9.2499 0.864383 9.2499H11.6121L8.20312 12.6471C8.03831 12.812 7.94751 13.026 7.94751 13.2605C7.94751 13.4948 8.03831 13.7119 8.20312 13.8767L8.72773 14.3998C8.89268 14.5647 9.11238 14.6546 9.34705 14.6546C9.58145 14.6546 9.80129 14.5635 9.96623 14.3986L15.7444 8.62044C15.9097 8.45498 16.0007 8.2341 16 7.99931C16.0005 7.76373 15.9097 7.54272 15.7443 7.37752Z",
    fill: "#5A46A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.2a70c6451e52446426c0214d01ed5bb2.svg";
export { ForwardRef as ReactComponent };